import React from 'react';
import { Trash2, Download } from 'lucide-react';

const statusColors = {
  active: 'bg-green-500',
  unsubscribed: 'bg-gray-500',
};

export function SubscribersTab({ subscribers, onDelete, onExport }) {
  return (
    <div className="bg-gray-800/50 rounded-xl border border-gray-700 overflow-hidden">
      <div className="flex justify-between items-center p-4 border-b border-gray-700">
        <h3 className="text-lg font-medium text-white">Newsletter Subscribers</h3>
        <button
          onClick={onExport}
          className="flex items-center gap-2 bg-teal-600 hover:bg-teal-500 px-4 py-2 rounded-lg text-white text-sm transition-colors"
          data-testid="export-subscribers-btn"
        >
          <Download size={16} />
          Export CSV
        </button>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-700/50">
            <tr>
              <th className="text-left px-6 py-4 text-gray-300 font-medium">Email</th>
              <th className="text-left px-6 py-4 text-gray-300 font-medium">Status</th>
              <th className="text-left px-6 py-4 text-gray-300 font-medium">Subscribed</th>
              <th className="text-center px-6 py-4 text-gray-300 font-medium">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-700">
            {subscribers.length === 0 ? (
              <tr>
                <td colSpan={4} className="text-center py-8 text-gray-500">
                  No subscribers yet
                </td>
              </tr>
            ) : (
              subscribers.map((sub) => (
                <tr key={sub.id} className="hover:bg-gray-700/30">
                  <td className="px-6 py-4">{sub.email}</td>
                  <td className="px-6 py-4">
                    <span className={`px-3 py-1 rounded-full text-xs font-medium ${statusColors[sub.status] || 'bg-gray-500'} text-white`}>
                      {sub.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-gray-400">
                    {new Date(sub.subscribed_at).toLocaleDateString()}
                  </td>
                  <td className="px-6 py-4 text-center">
                    <button
                      onClick={() => onDelete(sub.email)}
                      className="text-red-400 hover:text-red-300 p-2"
                      data-testid={`delete-sub-${sub.email}`}
                    >
                      <Trash2 size={18} />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
